import React from 'react';
import { Button } from 'semantic-ui-react';
import cx from 'classnames';

type Props = {
  onToggle: (style?: string) => void,
  active: boolean,
  label: string,
  styleEffect: string,
  displayStyle?: string,
};

const StyleButton = ({
  onToggle,
  active,
  label,
  styleEffect,
  displayStyle,
}: Props) => {
  const onLocalToggle = e => {
    e.preventDefault();
    onToggle(styleEffect);
  };

  const buttonClass = cx('ui icon button', {
    active,
  });

  if (displayStyle) {
    return (
      <Button
        type="button"
        className={buttonClass}
        onMouseDown={onLocalToggle}
        style={{ textAlign: 'center' }}
        icon={displayStyle}
      />
    );
  }

  return (
    <Button type="button" className={buttonClass} onMouseDown={onLocalToggle}>
      {label}
    </Button>
  );
};

export default StyleButton;



// WEBPACK FOOTER //
// ./src/shared/components/RichTextMenuButton.js